import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const contentStyle = {
    paddingTop: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    paddingBottom: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(30), pxToRem(30)],
    paddingRight: [pxToRem(11), pxToRem(11), pxToRem(30), pxToRem(30)],
    maxWidth: [pxToRem(298), pxToRem(340), pxToRem(678), pxToRem(678)],
    maxHeight: [pxToRem(249), pxToRem(249), pxToRem(225), pxToRem(225)],
    borderRadius: '0px',
    textAlign: 'center'
}

export const contentStyleFromCheckoutSignout = {
    ...contentStyle,
    paddingLeft: [pxToRem(19), pxToRem(19), pxToRem(30), pxToRem(30)],
    paddingRight: [pxToRem(19), pxToRem(19), pxToRem(43), pxToRem(43)],
    paddingBottom: [pxToRem(30), pxToRem(30), pxToRem(34), pxToRem(34)],
    maxHeight: 'auto'
}

// Confirm Item Removal (model-title)
export const dialogTitleStyle = {
    width: ['90%', '90%', pxToRem(678), pxToRem(678)],
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexShrink: 0,
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(18), pxToRem(18), pxToRem(22), pxToRem(22)],
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    margin: '0 auto',
    [`@media (max-width: ${sizes.container.sm})`]: {
        width: pxToRem(268),
        textAlign: 'center',
        height: pxToRem(42),
        fontSize: pxToRem(18)
    }
}

export const dialogStyleFromCheckoutSignout = {
    ...dialogTitleStyle,
    width: ['100%', '100%', '100%', '100%']
}

// msg-Are you sure you want to remove this item from your wishlist?
export const confirmationMessageStyle = {
    marginTop: pxToRem(15),
    marginBottom: '0px',
    padding: '0px',
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        textAlign: 'center'
    }
}

export const confirmationMessageStyleFromCheckoutSignout = {
    ...confirmationMessageStyle,
    marginTop: [pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)]
}

// Button Container- (wraps both buttons)

export const buttonContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: pxToRem(10),
    marginTop: pxToRem(20),
    [`@media (max-width: ${sizes.container.md})`]: {
        flexDirection: 'column',
        justifyContent: 'center',
        gap: pxToRem(15)
    }
}

// Cancel Button
export const alternateActionButton = {
    order: [2, 2, 1, 1],
    flex: '1',
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    justifyContent: 'center',
    alignItems: 'center',
    border: `${pxToRem(1)} solid ${colors.cav_red}`,
    borderRadius: '0px',
    color: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
        borderRadius: '0px',
        backgroundColor: 'cav_red',
        color: 'white'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        width: '100%',
        height: pxToRem(42),
        padding: `${pxToRem(10)} ${pxToRem(20)}`,
        flexShrink: 0
    }
}

// Yes, Remove Item Button
export const primaryActionButton = {
    order: [1, 1, 2, 2],
    flex: '1',
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0px',
    backgroundColor: 'cav_red',
    color: 'white',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
        borderRadius: '0px',
        backgroundColor: 'white',
        border: `${pxToRem(1)} solid`,
        color: 'cav_red'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        width: '100%',
        height: pxToRem(42),
        padding: `${pxToRem(10)} ${pxToRem(20)}`,
        flexShrink: 0
    }
}
